import { Save } from '@mui/icons-material';
import {
    Box,
    Button,
    Card,
    Grid,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import { H6 } from 'components/Typography';
import FormCheckin from 'page-sections/operator/checkin/formCheckin';
import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';

const Checkin = () => {
    const [listRoom, setListRoom] = useState([]);
    const [room, setRoom] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const getData = async () => {
        await axiosInstance
            .get('api/prv/checkin-rooms')
            .then(({ data }) => setListRoom(data))
            .catch((err) => console.log(err));
    };

    const handleClick = () => {
        if (!room) {
            alert('Please Choose Room!');
        } else {
            setOpenModal(true);
        }
    };

    useEffect(() => {
        getData();
    }, []);
    
    return (
        <Box pt={2} pb={4}>
            <FormCheckin
                data={room}
                open={openModal}
                onClose={() => setOpenModal(false)}
            />
            <Typography variant="h3" component="h1" paragraph>
                Checkin
            </Typography>
            <Card
                sx={{
                    padding: '2rem 1rem',
                }}
            >
                <Grid container spacing={2}>
                    <Grid container item xs={12}>
                        <Grid item xs={12}>
                            <H6 mb={1}>Choose Room</H6>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            spacing={2}
                            alignItems="stretch"
                        >
                            <Grid item xs={6}>
                                <Select
                                    size="small"
                                    variant="outlined"
                                    fullWidth
                                    displayEmpty
                                    value={room?.value ?? ''}
                                    onChange={(e) => {
                                        const selectedItemIdValue = e.target.value;
                                        if (selectedItemIdValue === '') {
                                            setRoom(null);
                                            return;
                                        }
                                        const selectedItem = listRoom.find(
                                            (item) =>
                                                String(item.value) ===
                                                String(selectedItemIdValue),
                                        );
                                        setRoom(
                                            selectedItem
                                                ? {
                                                      value: selectedItem.value,
                                                      label: selectedItem.label,
                                                      title: selectedItem.additional.title,
                                                  }
                                                : null,
                                        );
                                    }}
                                >
                                    <MenuItem value="">Choose room</MenuItem>
                                    {listRoom.map((item) => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item xs={3}>
                                <Button
                                    onClick={handleClick}
                                    variant="contained"
                                    size="small"
                                    style={{ height: '100%' }}
                                    endIcon={<Save />}
                                >
                                    Set Room
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </Box>
    );
};

export default Checkin;
